export const baseUrl="api/zhxg-yxxt";


// WEBPACK FOOTER //
// ./utils/NHPrefixUrl.js